import React, { Fragment, PureComponent } from 'react'
import { IconButton, Popover, List, ListItem, ListItemIcon, ListItemText, Collapse, Divider } from '@material-ui/core'
import { Description, DirectionsBus, ExpandLess, ExpandMore, Person, People } from '@material-ui/icons'

const popoverOptions = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right',
  }
}

const popoverPaperStyles = {
  maxWidth: 300,
  maxHeight: 400
}

export class StatementsBase extends PureComponent {
  state = {
    anchorEl: null,
    openCarriers: false,
    openUsers: false,
  }

  componentDidMount() {
    const { getUsers, bookingUsers } = this.props
    if(!bookingUsers.length) {
      getUsers()
    }
  }
  
  handleOpen = e => this.setState({ anchorEl: e.currentTarget })

  closePopover = () => this.setState({ anchorEl: null, openCarriers: false })

  openSubList = name => () => this.setState(state => ({ [name]: !state[name] }))

  onCarrierClick = id => () => {
    this.closePopover()

    this.props.getCarriersBookings(id)
  }

  renderCarriers = ({ id, label }) => (
    <ListItem 
      button 
      key={id}
      onClick={this.onCarrierClick(id)}
    >
      <ListItemIcon>
        <Person />
      </ListItemIcon>
      <ListItemText inset primary={label} />
    </ListItem>
  )

  onUserClick = id => () => {
    this.closePopover()

    this.props.getUserBookings(id)
  }

  renderUsers = ({ id, name }) => (
    <ListItem 
      button 
      key={id}
      onClick={this.onUserClick(id)}
    >
      <ListItemIcon>
        <Person />
      </ListItemIcon>
      <ListItemText inset primary={name} />
    </ListItem>
  )

  render() {
    const { anchorEl, openCarriers, openUsers } = this.state
    const { carriers, bookingUsers } = this.props

    return (
      <Fragment>
        <IconButton color='inherit' onClick={this.handleOpen}>
          <Description />
        </IconButton>

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={this.closePopover}
          PaperProps={{
            style: popoverPaperStyles
          }}
          {...popoverOptions}
        >
          <List>

            <ListItem button onClick={this.openSubList('openCarriers')}>
              <ListItemIcon>
                <DirectionsBus />
              </ListItemIcon>
              <ListItemText inset primary='Перевізники' />
              {openCarriers ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openCarriers} timeout='auto' unmountOnExit>
              <Divider />
              <List disablePadding>
                {carriers.map(this.renderCarriers)}
              </List>
            </Collapse>

            <ListItem button onClick={this.openSubList('openUsers')}>
              <ListItemIcon>
                <People />
              </ListItemIcon>
              <ListItemText inset primary='Диспетчери' />
              {openUsers ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openUsers} timeout='auto' unmountOnExit>
              <Divider />
              <List disablePadding>
                {bookingUsers.map(this.renderUsers)}
              </List>
            </Collapse>

          </List>
        </Popover>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Statements/Statements.js